import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { I18nService } from '@app/core/i18n.service';

interface ErrorsDetails {
  title: string
  description: string,
  login: boolean
}

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: true,
  imports: [MatButtonModule]
})
export class ErrorPageComponent implements OnInit {

  BAD_REQUEST_LOCALIZED: string = $localize`:Bad Request Title text|Message header displayed when there is a bad request@@BadRequest:Bad Request`;
  BAD_REQUEST_DESCRIPTION_LOCALIZED: string = $localize`:Bad Request description text|Message displayed when there is a bad request@@BadRequestErrorMessage:Your request resulted in an error. Try going back to previous page or `;

  UNAUTHORIZED_LOCALIZED: string = $localize`:UnAuthorized Title text|Message header displayed when there is a Un-Authorized access@@Unauthorized:Unauthorized`;
  UNAUTHORIZED_DESCRIPTION_LOCALIZED: string = $localize`:UnAuthorized description text|Message displayed when there is a UnAuthorized access@@UnauthorizedErrorMessage:Sorry, your request could not be processed. Authentication is required to access this page. Reload the page to try again. `;

  ACCESS_DENIED_LOCALIZED: string = $localize`:Access Denied Title text|Message header displayed when there is a access denied@@AccessDenied:Access Denied/Forbidden`;
  ACCESS_DENIED_DESCRIPTION_LOCALIZED: string = $localize`:Access Denied description text|Message displayed when there is a access denied@@AccessDeniedErrorMessage:The page or resource you were trying to reach is forbidden for some reason. Reload the page to try again. `;

  PAGE_NOT_FOUND_LOCALIZED: string = $localize`:Page Not found Title text|Message header displayed when there is a Page not found@@PageNotFound:Page Not Found`;
  PAGE_NOT_FOUND_DESCRIPTION_LOCALIZED: string = $localize`:Page not found description text|Message displayed when there is a Page ot found@@PageNotFoundErrorMessage:Uh oh, we can't seem to find the page you're looking for. Try going back to previous page or `;

  INTERNAL_SERVER_ERROR_LOCALIZED: string = $localize`:Internal Server Error Title text|Message header displayed when there is a Internal Server Error@@InternalServerError:Internal Server Error`;
  INTERNAL_SERVER_ERROR_DESCRIPTION_LOCALIZED: string = $localize`:Internal Server Error description text|Message displayed when there is a Internal Server Error@@InternalServerErrorMessage:Something went wrong at our end. We apologies and are fixing the problem. Please try again at a later stage. `;

  BAD_GATE_WAY_LOCALIZED: string = $localize`:Bad Gateway Title text|Message header displayed when there is a Bad Gateway@@BadGateWay:Bad Gateway`;
  BAD_GATE_WAY_DESCRIPTION_LOCALIZED: string = $localize`:Bad Gateway description text|Message displayed when there is a Bad Gateway@@BadGateWayErrorMessage:The server encountered a temporary error and could not complete your request. Please try again later. `;

  SERVICE_UNAVAILABLE_LOCALIZED: string = $localize`:Service Unavailable Title text|Message header displayed when there is Service Unavailable@@ServiceUnavailable:Service Unavailable`;
  SERVICE_UNAVAILABLE_DESCRIPTION_LOCALIZED: string = $localize`:Service Unavailable description text|Message displayed when there is Service Unavailable@@ServiceUnavailableErrorMessage:The server is currently unavailable and could not complete your request. Please try again later. `;

  TIMEOUT_LOCALIZED: string = $localize`:Gateway Timeout Title text|Message header displayed when there is a Gateway Timeout@@GatewayTimeout:Gateway Timeout`;
  TIMEOUT_DESCRIPTION_LOCALIZED: string = $localize`:Gateway Timeout description text|Message displayed when there is a Gateway Timeout@@GatewayTimeoutErrorMessage:Something went wrong. The page can't be reached. Please try again after some time. `;

  TRY_TO_LOGIN_MESSAGE_LOCALIZED: string = $localize`:Try Login display text|When the user login fails, User is displayed with try login again message@@TryToLoginMessage:Try to login in again`;
  RETURN_TO_HOME_PAGE_MESSAGE_LOCALIZED: string = $localize`:Return to Home text|When any action returns error, return to home page message is shown@@GoToHomePageMessage:Return to Home page`;


  errorsDetails: Map<number, ErrorsDetails> = new Map<number, ErrorsDetails>([
    [400, {
      title: this.BAD_REQUEST_LOCALIZED,
      description: this.BAD_REQUEST_DESCRIPTION_LOCALIZED,
      login: false
    }],
    [401, {
      title: this.UNAUTHORIZED_LOCALIZED,
      description: this.UNAUTHORIZED_DESCRIPTION_LOCALIZED,
      login: true
    }],
    [403, {
      title: this.ACCESS_DENIED_LOCALIZED,
      description: this.ACCESS_DENIED_DESCRIPTION_LOCALIZED,
      login: true
    }],
    [404, {
      title: this.PAGE_NOT_FOUND_LOCALIZED,
      description: this.PAGE_NOT_FOUND_DESCRIPTION_LOCALIZED,
      login: true
    }],
    [500, {
      title: this.INTERNAL_SERVER_ERROR_LOCALIZED,
      description: this.INTERNAL_SERVER_ERROR_DESCRIPTION_LOCALIZED,
      login: true
    }],
    [502, {
      title: this.BAD_GATE_WAY_LOCALIZED,
      description: this.BAD_GATE_WAY_DESCRIPTION_LOCALIZED,
      login: true
    }],
    [503, {
      title: this.SERVICE_UNAVAILABLE_LOCALIZED,
      description: this.SERVICE_UNAVAILABLE_DESCRIPTION_LOCALIZED,
      login: true
    }],
    [504, {
      title: this.TIMEOUT_LOCALIZED,
      description: this.TIMEOUT_DESCRIPTION_LOCALIZED,
      login: true
    }],
  ])

  error!: ErrorsDetails;

  constructor(
    private _router: Router,
    protected i18nService: I18nService
  ) {}

  ngOnInit(): void {
    // get state that is passed by routing - access token per organization
    const errorState = this._router.lastSuccessfulNavigation?.extras.state as { errorCode: number };
    
    if(!errorState) {
      this.error = this.errorsDetails.get(404)!
      return
    }
    
    this.error = this.errorsDetails.get(errorState.errorCode) ?? this.errorsDetails.get(404)! // 404 is a default error - guaranteed to be in the errorDetails

  }

  navigateToHomeOrLogin(login: boolean) {
    login ? this._router.navigate(['login']) : this._router.navigate(['home'])
  }
}
